<template>
    <v-chip :label="label" :small="small" :outlined="outlined" :color="color" :text-color="textColor" class="px-2">
        <span v-if="value && isValueObject">
            <span
          >{{ `${value.name}:` }}
        </span>&nbsp;
        <strong>{{value.text}}</strong>
        </span>
        <span v-else>{{value}}</span>
        </v-chip
    >
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Object]
        },
        label: {
            type: Boolean,
            default: true,
        },
        small: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
            default: "grey lighten-2",
        },
        textColor: {
            type: String,
            default: "black",
        }
    },
    computed: {
        isValueObject() {
            return typeof this.value === "object";
        }
    }
}
</script>